(() => {
	let header     = document.querySelector('.header');
	let hamburgers = document.querySelectorAll('.js-header__hamburger');
	let closeMenu = document.querySelector('.js-menu__close');
	let searchToggle = document.querySelector('.js-header__search');
	let items      = document.querySelectorAll('.menu__item');
	let menu = document.querySelector(".js-menu__container");
	let hamburgerText = document.querySelector(".js-hamburger-text");

	if (closeMenu) {
		closeMenu.addEventListener('click', () => {
			run();
		});
	}

	document.addEventListener("keyup", (function(e) { 
		if (e.keyCode == 27) {
			run();
		}
	}));

	if (hamburgers.length > 0) {
		hamburgers.forEach(el => {
			el.addEventListener('click', () => {
				run();
			});
		})
		
	}

		
	if (searchToggle && hamburgers) {
		let searchInput = document.querySelector(".js-menu__searchfield");
		searchToggle.addEventListener('click', () => {
			run();
			searchInput.focus();
			
		});
	}


	Array.prototype.forEach.call(items, (item, ind) => {
		let multiplier             = ind + 1;
		item.style.transitionDelay = `${100 + (multiplier * 50)}ms`;
	});

	function run(){
		menu.classList.toggle('active');
		
		hamburgers.forEach(el => {
			el.classList.toggle('is-active');
		})

		header.classList.toggle('menu-active');
		document.body.classList.toggle('menu-active');

		

		if(menu.classList.contains('active')){
			
			document.body.style.overflow = "hidden";

			if(window.innerWidth > 1024){
				
				hamburgers.forEach(el => {
					el.style.display = "none";
				})
				
			} else {
				hamburgerText.innerHTML = hamburgerText.dataset.textClose;
			}
			
		} else {

			document.body.style.overflow = "auto";

			if(window.innerWidth > 1024){
				hamburgers.forEach(el => {
					el.style.display = "";		
				})
				
			} else {
				hamburgerText.innerHTML = hamburgerText.dataset.textOpen;
			}
		}
	}

})();